export interface User {
  subject: string;
  userId: string;
  givenName: string;
  familyName: string;
  name: string;
  locality: string;
  customerNumber?: string;
}
